const angular = require('angular');
const app = angular.module('learn-services');
app.factory('AnalyticsProvider', ['$window', function($window) {
    var self = this;
    self.AnalyticsProvider = {
      init: function() {
      },
      setUserInfo: function(userAuthToken) {
        try {
          var user = userAuthToken.user;
          var company = userAuthToken.company;
          $window.plantrack.identify(user._id, {
            email: user.email,
            name: user.first_name + ' ' + user.last_name,
            companyId: company._id
          });

          $window.gtag('set', {'user_id': user.email});
          $window.ga('set', {'user_id': user.email});

        } catch (e) {
          console.error(e.message, e.name);
        }
      },
      trackEvent: function(event, attributes) {

        try {
          //planhat
          $window.plantrack.track(event);
          //newrelic       
          newrelic.addPageAction(event, attributes);
        } catch (e) {
          console.error(e.message, e.name);
        }
      }
    };
    return self.AnalyticsProvider;
  }]);